import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4f3bfc04")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgWrapper = _resolveComponent("SvgWrapper")

  return (_ctx.outline)
    ? (_openBlock(), _createBlock(_component_SvgWrapper, {
        key: 0,
        class: "image-ellipse-outline",
        overflow: "visible",
        width: _ctx.width,
        height: _ctx.height
      }, {
        default: _withId(() => [
          _createVNode("ellipse", {
            "vector-effect": "non-scaling-stroke",
            "stroke-linecap": "butt",
            "stroke-miterlimit": "8",
            "stroke-linejoin": "",
            fill: "transparent",
            cx: _ctx.width / 2,
            cy: _ctx.height / 2,
            rx: _ctx.width / 2,
            ry: _ctx.height / 2,
            stroke: _ctx.outlineColor,
            "stroke-width": _ctx.outlineWidth,
            "stroke-dasharray": _ctx.outlineStyle === 'dashed' ? '10 6' : '0 0'
          }, null, 8, ["cx", "cy", "rx", "ry", "stroke", "stroke-width", "stroke-dasharray"])
        ]),
        _: 1
      }, 8, ["width", "height"]))
    : _createCommentVNode("", true)
})